<template>
    <transition :name="fadeIn">
        <div class="message" v-show="show">
            <!-- 操作弹框 -->
            <div class="dialog" :class="setDialogBg" ref="dialog">
                <div class="content">
                    <i :class="setIconClass"></i>
                    <span>{{text}}</span>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'Main',
  props: {
    show: {
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'success',
    },
  },
  data() {
    return {
      // 默认显示持续时间（毫秒）
      duration: 1500,
      // 默认图标（类名）
      iconClass: 'el-icon-info',
    };
  },

  computed: {
    setIconClass() {
      return `el-icon-${this.type}`;
    },
    setDialogBg() {
      return `dialog-${this.type}`;
    },
    fadeIn() {
      return 'fadeIn';
    },
  },
  watch: {
    show(newVal, oldVal) {
      if (this.show) {
        setTimeout(() => {
          // eslint-disable-next-line vue/no-mutating-props
          this.show = false;
        }, this.duration);
      }
    },
  },
};
</script>

<style scope lang="css">
    .message {
        position :fixed;
        width :100%;
        height: 100%;
        z-index: 9999;
    }
    .dialog {
        position: absolute;
        left: 40%;
        right: 50%;
        width: 200px;
        z-index:999;
        padding:15px;
        transform: translateY(-650%);
        border-radius: 4px;
        border-width :1px;
        font-size: 22px
    }

    .dialog-success {
        background: rgba(103, 194, 58, .2);
        color: rgb(103, 194, 58)
    }

    .dialog-warning {
        background: rgba(230, 162, 60, .2);
        color: rgb(230, 162, 60);
    }

    .dialog-error {
        background: rgba(245, 108, 108, .2);
        color: rgb(245, 108, 108)
    }

    .dialog-info {
        background: rgba(144, 147, 153, .2);
        color: rgb(144, 147, 153)
    }

    .content {
        text-align: center
    }

    .content > i {
        margin-right: 5px
    }

    .fadeIn-enter-active, .fadeIn-leave-active {
        transition: opacity .5s
    }

    .fadeIn-enter, .fadeIn-leave-to {
        opacity: 0
    }

</style>



// WEBPACK FOOTER //
// src/common/plugin/message/Main.vue